<!-- 地图左上角的预警类型过虑器 -->
<template>
  <dl class="warning-filter" v-toggle>
    <dt :title="selectedLabelTip">过滤报警类别</dt>
    <dd>
      <ul>
        <li @click="toggleSelected(item)" :class="{ disabled: item.disabled, selected: item.selected }" :style="`--icon: url(/images/warning/${item.type}/p${item.category && ('' + item.category).padStart(4, '0')}${item.level && ('' + item.level).padStart(3, '0')}.png)`" :key="`${i}.${item.code}`" v-for="(item, i) in list">
          <span class="label" :title="item.label">{{ item.label || `编号为${item.category}${item.level}的预警[${item.type}]` }}</span>
          <span class="count" v-if="item.count">{{ item.count }}</span>
        </li>
      </ul>
    </dd>
  </dl>
</template>

<script>
export default {
  name: 'warningFilter',
  props: {
    // [{ label: '台风预警', code: '0001', disabled: 0, selected: false, count: 11 },]
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      list: [],
    };
  },
  computed: {
    selectedLabelTip() {
      let self = this;
      const selected = self.list
        .filter((v) => v.selected)
        .map((v) => v.label)
        .join('、');
      const tip = `已选预警类别：${selected.length ? selected : '无'}`;
      return tip;
    },
  },
  watch: {
    value: {
      handler(val) {
        this.list = val;
      },
      immediate: true,
    },
  },
  methods: {
    toggleSelected(item) {
      let self = this;
      self.list.forEach((v, i) => {
        if (!v.disabled && v.type === item.type && v.category === item.category && v.level === item.level) {
          self.$set(self.list, i, { ...v, selected: !v.selected });
        }
      });
      const list = self.list;
      // console.log('toggleSelected', list);
      self.$emit('input', list);
      self.$emit('changed', list);
    },
  },
  directives: {
    // 点击dt，切换dd的显示状态，点击页面空白处后收起dt
    toggle: {
      inserted(el) {
        // console.log('toggle mounted', el);
        const dt = el.querySelector('dt');
        const dd = el.querySelector('dd');

        // 初始状态设置为隐藏
        dd.style.display = 'none';
        dd.style.overflow = 'hidden';

        // 计算vh值
        const calculateVH = (px) => {
          return (px / 1080) * window.innerHeight + 'px';
        };

        // 点击dt切换显示状态
        dt.addEventListener('click', (e) => {
          e.stopPropagation();
          if (dd.style.display === 'none') {
            dd.style.height = '0';
            dd.style.display = 'block';
            requestAnimationFrame(() => {
              dd.style.height = calculateVH(221);
              dd.style.transition = 'height 0.1s ease-in-out';
            });
          } else {
            dd.style.height = '0';
            dd.style.transition = 'height 0.1s ease-in-out';
            setTimeout(() => {
              dd.style.display = 'none';
            }, 100);
          }
          // dt.classList.toggle('active');
        });

        // 点击页面其他地方关闭
        const handleClickOutside = (e) => {
          if (!el.contains(e.target) && dd.style.display !== 'none') {
            dd.style.height = '0';
            dd.style.transition = 'height 0.1s ease-in-out';
            setTimeout(() => {
              dd.style.display = 'none';
            }, 100);
          }
        };

        // 监听窗口大小变化，更新高度
        const updateHeight = () => {
          if (dd.style.display !== 'none') {
            dd.style.height = calculateVH(221);
          }
        };
        window.addEventListener('resize', updateHeight);

        // 添加点击事件监听
        document.addEventListener('click', handleClickOutside);

        // 清理事件监听
        el._cleanup = () => {
          document.removeEventListener('click', handleClickOutside);
          window.removeEventListener('resize', updateHeight);
        };
      },
      unbind(el) {
        // 组件销毁时清理事件监听
        el._cleanup && el._cleanup();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}
@mixin line($count: 1) {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: $count;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  hyphens: auto;
}
%scrollbar {
  overflow: auto;

  &::-webkit-scrollbar {
    width: vh(4);
    height: vh(4);
  }

  &::-webkit-scrollbar-track {
    // background: rgba(10, 77, 19, 0.2);
    background: transparent;
    border-radius: vh(4);
  }

  &::-webkit-scrollbar-thumb {
    background: #b06400;
    border-radius: vh(20);
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #b06400;
  }

  &::-webkit-scrollbar-corner {
    background: #b06400;
  }
}
dl.warning-filter {
  position: relative;
  margin: 0;
  padding: 0;
  user-select: none;
  dt {
    width: vw(57);
    height: vh(40);
    background: url(../images/btn_yjx_py.png) no-repeat left top;
    background-size: 100% 100%;
    cursor: pointer;
    text-indent: -9999px;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    &:hover,
    &.active {
      background-image: url(../images/btn_yjx_c_py.png);
    }
    &:active {
      left: 1px;
      top: 1px;
    }
  }
  dd {
    position: absolute;
    left: 0;
    top: vh(50);
    background: url(../images/bg_map_yjx.png) no-repeat left top;
    background-size: 100% 100%;
    width: vw(149);
    padding: vh(33) 0 0;
    margin: 0;
    overflow: hidden;
    transition: height 0.1s ease-in-out;
    // box-shadow: vh(3) vh(3) vh(8) 0 rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(2px);
    ul {
      list-style: none;
      padding: 0 0 vw(5);
      margin: 0;
      overflow: auto;
      height: 100%;
      @extend %scrollbar;
      li {
        height: vh(30);
        line-height: vh(30);
        font-size: fontSize(14);
        font-weight: bold;
        color: #ffffff99;
        padding: 0 vw(8);
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        @include line(2);
        &.disabled {
          cursor: not-allowed;
          color: #ffffff99;
        }
        &.selected {
          color: #ffcb87;
        }
        &:hover {
          background-color: #614219;
        }
        &::before {
          content: '';
          display: inline-block;
          width: vw(31);
          height: vw(24);
          background: no-repeat center center;
          background-image: var(--icon);
          background-size: auto 100%;
          vertical-align: middle;
          margin-right: vw(7);
        }
        span {
          display: inline-block;
          vertical-align: middle;
          &.count {
            margin-left: vw(5);
            font-weight: normal;
            opacity: 0.5;
            &:before {
              content: '(';
            }
            &:after {
              content: ')';
            }
          }
        }
      }
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-10px);
  }
}
</style>
